import { Card } from "@/components/ui/card";
import { FooterNavigation } from "./FooterNavigation";
import { Logo } from "./Logo";
import { MainNavigation } from "./MainNavigation/MainNavigation";

export const Sidebar = () => {
  return (
    <Card className="bg-gray-900 px-2 pb-2 pt-2  h-full">
      <Logo />
      <MainNavigation />
      <FooterNavigation />
    </Card>
  );
};
